// Reserve header space once before paint. Subsequent measurements come from
// ResizeObserver so font/viewport changes do not force additional layout reads.
export function observeHeaderHeight(node, root = document.documentElement) {
  let previousHeight = null;
  const applyHeight = (rawHeight) => {
    const height = Math.max(0, Math.round(rawHeight));
    if (!Number.isFinite(height) || height === previousHeight) return;
    previousHeight = height;
    root.style.setProperty("--landing-header-height", `${height}px`);
    root.style.setProperty("--landing-header-offset", `${height}px`);
    root.style.setProperty("--landing-header-extra", "0px");
  };
  applyHeight(node.getBoundingClientRect().height);
  let disconnect;
  if (typeof ResizeObserver !== "undefined") {
    const observer = new ResizeObserver(([entry]) => {
      if (!entry) return;
      const box = Array.isArray(entry.borderBoxSize) ? entry.borderBoxSize[0] : entry.borderBoxSize;
      applyHeight(box?.blockSize ?? node.getBoundingClientRect().height);
    });
    observer.observe(node, { box: "border-box" });
    disconnect = () => observer.disconnect();
  } else {
    let frame = 0;
    const measure = () => applyHeight(node.getBoundingClientRect().height);
    const schedule = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => { frame = 0; measure(); });
    };
    window.addEventListener("resize", schedule, { passive: true });
    window.addEventListener("orientationchange", schedule);
    disconnect = () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener("resize", schedule);
      window.removeEventListener("orientationchange", schedule);
    };
  }
  return () => {
    disconnect();
    root.style.removeProperty("--landing-header-height");
    root.style.removeProperty("--landing-header-offset");
    root.style.removeProperty("--landing-header-extra");
  };
}
